import { combineReducers } from "redux";
import { adjusterReducer } from "./adjusterReducer";
import alertReducer from "./alertReducer";
import conversationReducer from "./conversationReducer";
import { loaderReducer } from "./loaderReducer";
import snackbarReducer from "./snackbarReducer";
import userReducer from "./userReducer";


const rootReducer = combineReducers({
    user: userReducer,
    chat: conversationReducer,
    snackbar: snackbarReducer,
    alert: alertReducer,
    loader: loaderReducer,
    adjusters: adjusterReducer
})

export default rootReducer;


